<template>
	<screen class="update-user-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">App Details</h2>
			</ui-header>
		</template>
		<div class="app-details">
			<label v-if="build_type === 'web'">
				<ui-label>Version</ui-label>
				<ui-input v-model="app_version" disabled="disabled" />
			</label>
			<label>
				<ui-label>Timezone</ui-label>
				<ui-input
					placeholder="America/Denver"
					disabled="disabled"
					v-model="timezone"
				/>
			</label>
			<label>
				<ui-label>Environment</ui-label>
				<ui-input
					placeholder="Staging"
					v-model="app_env"
					disabled="disabled"
				/>
			</label>
			<label>
				<ui-label>Build</ui-label>
				<ui-input
					placeholder="Staging"
					v-model="build_type"
					disabled="disabled"
				/>
			</label>
		</div>
	</screen>
</template>

<script>
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
import UiInput from '../../ui/Input'
import UiLabel from '../../ui/Label'
import Screen from '../../ui/Screen'
import moment from 'moment-timezone'
import { version } from '../../../package'

export default {
	name: 'AppDetails',
	components: { Screen, UiButton, UiInput, UiHeader, UiLabel },
	data() {
		return {
			isLoading: false,
			timezone: 'America/Denver',
			meow: process.env.VUE_APP_MEOW,
			app_env: process.env.VUE_APP_ENV,
			build_type: process.env.VUE_APP_TYPE,
			app_version: version
		}
	},
	methods: {
		onBack() {
			this.navigate({ name: 'settings' }, 'back')
		}
	},
	mounted() {
		this.timezone = moment.tz.guess()
	}
}
</script>

<style lang="scss">
.update-user-view {
	.app-details {
		padding: 15px 0px;
	}
}
.needed {
	position: absolute;
	right: 10px;
	top: 10px;
	height: 15px;
	width: 15px;
	color: $red;
}
</style>
